<template>
  <div class="endbox">
    <div v-if="!isPc" class="h5Box">
      <div
        class="handleBox flex_center"
        style="position: fixed; margin-top: 10px; right: 5px"
      >
        <help-tip ref="helpTipRef"></help-tip>
        <div class="langBox">
          <change-i18n-component></change-i18n-component>
        </div>
      </div>
      <div class="h5bg">
        <img src="../../assets/login/h5bg.png" alt="" style="width: 100%" />
        <img
          class="leftBoxEn"
          src="~@/assets/images/logo-blue-en.png"
          alt=""
          v-if="$store.state.dict.lang == 'en'"
        />
        <img
          class="leftBoxZh"
          src="~@/assets/images/logo-blue.png"
          alt=""
          v-if="$store.state.dict.lang == 'zh'"
        />
      </div>
    </div>
    <div class="loginpage" key="">
      <div class="loginHeader flex_center_between" v-if="isPc">
        <img
          class="leftBoxEn"
          src="~@/assets/images/logo-blue-en.png"
          alt=""
          v-if="$store.state.dict.lang == 'en'"
        />
        <img
          class="leftBoxZh"
          src="~@/assets/images/logo-blue.png"
          alt=""
          v-if="$store.state.dict.lang == 'zh'"
        />
        <div class="rightBox flex_center_between">
          <help-tip ref="helpTipRef"></help-tip>
          <div class="langBox">
            <change-i18n-component></change-i18n-component>
          </div>
        </div>
      </div>
      <!-- 登录页面框框  -->
      <div class="device-type-cla">
        <div class="out-box-login" v-if="true">
          <div class="title-span">
            <span v-if="$store.state.dict.lang == 'zh'">{{
              meetingSubject
            }}</span>
            <span v-if="$store.state.dict.lang == 'en'">{{
              meetingSubjectEn
            }}</span>
          </div>
          <!-- <div class="chose-out-role">
            <span class="chose-in" :class="loginRole == 'login'?'active':''" @click="changeLoginRole('login')">普通用户</span>
            <span class="chose-in" :class="loginRole == 'adminLogin'?'active':''" @click="changeLoginRole('adminLogin')">管理员</span>
          </div> -->

          <div class="chose-way-out">
            <span
              :class="activeWay == 'mail' ? 'active' : ''"
              @click="choseWayFunc('mail')"
              >{{ $t("common.password") }}</span
            >
            <div class="shu"></div>
            <span
              :class="activeWay == 'phone' ? 'active' : ''"
              @click="choseWayFunc('phone')"
              >{{ $t("common.phone") }}</span
            >
            <!-- 	<template>
                <el-radio v-model="loginRole" label="true">备选项</el-radio>
                <el-radio v-model="loginRole" label="false">备选项</el-radio>
              </template> -->
            <!-- <el-switch
              style="display: block"
              v-model="loginRole"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="普通用户"
              inactive-text="管理员"
                      :validate-event=false
                      >
            </el-switch> -->
          </div>
          <div v-if="activeWay == 'mail'">
            <el-form
              ref="formMail"
              :model="formMail"
              :rules="rules"
              label-position="left"
              label-width="0px"
              label-height="100px"
              key="formLogin"
            >
              <el-form-item prop="mail">
                <el-input
                  v-model="formMail.mail"
                  :placeholder="transZhEnDynamic('pleaseInputAccount')"
                  auto-complete="off"
                >
                </el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-input
                  type="password"
                  v-model="formMail.password"
                  auto-complete="new-password"
                  :placeholder="transZhEnDynamic('pleaseInputPass')"
                ></el-input>
              </el-form-item>
              <el-row :gutter="24">
                <!--              <el-col :span="12">-->
                <!--                <div class="me-button-login" @click="loginMail">{{ $t("common.CommonUser") }}</div>-->
                <!--              </el-col>-->
                <el-col :span="24">
                  <div class="me-button-login" @click="loginMailAdmin">
                    <img
                      src="../../assets/login/useradmin.png"
                      alt=""
                      style="width: 18px"
                    />
                    {{ $t("common.ManageUser") }}
                  </div>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <div v-if="activeWay == 'phone'">
            <el-form
              ref="formMobile"
              :model="formPhone"
              :rules="rules"
              label-position="left"
              label-width="0px"
              label-height="100px"
            >
              <el-form-item prop="mobile">
                <el-input
                  v-model="formPhone.mobile"
                  :placeholder="transZhEnDynamic('pleaseInputPhone')"
                  auto-complete="off"
                >
                  <template slot="prepend">+86</template>
                </el-input>
              </el-form-item>
              <el-form-item prop="passcode">
                <el-input
                  type="password"
                  v-model="formPhone.passcode"
                  auto-complete="off"
                  :placeholder="transZhEnDynamic('pleaseInputVerificationCode')"
                >
                  <el-button
                    v-if="sendCode"
                    @click.native="sendMessage"
                    slot="append"
                    >{{ $t("common.getPhoneVerificationCode") }}
                  </el-button>
                  <el-button v-if="!sendCode" slot="append" style="width: 120px"
                    >{{ sendTime }}s{{ $t("common.sendAgain") }}
                  </el-button>
                </el-input>
              </el-form-item>
              <el-row :gutter="24">
                <!--              <el-col :span="12">-->
                <!--                <div id="loginMail" class="me-button-login" @click="loginMobile">{{ $t("common.CommonUser") }}</div>-->
                <!--              </el-col>-->
                <el-col :span="24">
                  <div
                    id="loginMailAdmin"
                    class="me-button-login"
                    @click="loginMobile('admin')"
                  >
                    <img
                      src="../../assets/login/useradmin.png"
                      alt=""
                      style="width: 18px"
                    />
                    {{ $t("common.ManageUser") }}
                  </div>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <div class="little-btn-div">
            <el-checkbox v-model="remberpass">{{
              $t("common.rememberPass")
            }}</el-checkbox>
            <el-checkbox v-model="autologin">{{
              $t("common.autoPass")
            }}</el-checkbox>
            <!-- <span class="blue14" @click="toFindPassBack"
              >{{ $t("common.forgetPass") }}？</span
            > -->
          </div>
          <div class="little-btn-divv2">
            <invite-component
              :userName="''"
              :meetingTitle="''"
              v-if="false"
            ></invite-component>
          </div>
        </div>
      </div>
      <!--  原来的-->
      <el-dialog
        :width="isPc ? '30%' : '100%'"
        title="选择角色(请选择角色，后续可在导航栏切换角色)"
        :visible.sync="dialogFormVisible"
      >
        <el-row>
          <el-col :span="12">
            <el-button
              type="primary"
              @click="loginChoiceRole('ROLE4')"
              style="width: 100%"
              >{{ $t("common.meetingPeo") }}</el-button
            >
          </el-col>
          <el-col :span="12">
            <el-button
              type="success"
              @click="loginChoiceRole('ROLE2')"
              style="width: 100%"
              >评审员</el-button
            >
          </el-col>
        </el-row>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">{{
            $t("common.cancelSpace")
          }}</el-button>
          <!-- <el-button type="primary" @click="dialogFormVisible = false">{{$t('common.trueText')}}</el-button> -->
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import helpTip from "@/components/tip/helpTip";
import inviteComponent from "@/components/common/inviteComponent";
import changeI18nComponent from "@/components/common/changeI18nComponent";
import utils from "@/utils/utils";
export default {
  components: {
    inviteComponent,
    changeI18nComponent,
    helpTip,
  },
  data() {
    return {
      isPc: true,
      dialogFormVisible: false,
      loginRole: "login",
      visibled: false,
      canGoIndex: false,
      formMail: {
        mail: "",
        password: "",
      },
      formPhone: {
        mobile: "",
        passcode: "",
      },
      dialogData: {
        roleCode: "",
        meetingCode: "",
        email: "",
        phoneNumber: "",
      },
      //页面使用的
      choseActive: "login", //login register
      activeWay: "mail",
      remberpass: false,
      autologin: false,
      //验证码相关
      sendCode: true,
      sendTime: 0,

      authorityData: null,
      meetingCode: null,

      meetingSubject: "会议管理系统",
      meetingSubjectEn: "Conference Management System",
    };
  },
  computed: {
    rules() {
      const rules = {
        mail: [
          {
            required: true,
            message: this.transZhEnDynamic("NotNull"),
            trigger: "blur",
          },
        ],
        mobile: [
          {
            required: true,
            message: this.transZhEnDynamic("NotNull"),
            trigger: "blur",
          },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: this.transZhEnDynamic("pleaseInputRightPhone"),
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: this.transZhEnDynamic("NotNull"),
            trigger: "blur",
          },
          {
            min: 6,
            max: 18,
            pattern: /^[A-Za-z0-9]{6,18}$/,
            message: this.transZhEnDynamic("pleaseInputPass"),
            trigger: "blur",
          },
        ],
        passcode: [
          {
            required: true,
            message: this.transZhEnDynamic("pleaseInputVerificationCode"),
            trigger: "blur",
          },
        ],
      };
      return rules;
    },
  },
  created() {
    this.isPc = utils.isPc();
  },
  mounted() {
    this.remberpass =
      localStorage.getItem("remberpass") === "true" ? true : false;
    if (this.remberpass) {
      this.formMail.mail = localStorage.getItem("username");
      this.formMail.password = localStorage.getItem("password");
      this.autologin =
        localStorage.getItem("autologin") === "true" ? true : false;
      if (this.autologin) {
        //document.getElementById("loginMail").click();
      }
    }
  },
  methods: {
    openHelp() {
      this.$refs["helpTipRef"].openDialog();
    },
    getMeetingDetail(meetingCode) {
      const data = {
        meetingCode: meetingCode,
      };
      this.$api.getMeetingDetail(data).then((res) => {
        if (res.code == 200) {
          if (res.data) {
            this.meetingSubject = res.data.meetingSubject;
            this.meetingSubjectEn = res.data.meetingSubjectEn;
          }
        }
      });
    },
    loginSuccess(data) {
      //将用户信息保存到session中然后放到header里
      let token = data.token;
      let meetingCode = data.meetingCode;
      let userId = data.userId;
      let roleCode = data.authorityInfoList[0].roleCode;
      let roleName = "";
      let phoneNumber = data.phoneNumber;
      let email = data.email;
      localStorage.setItem("userId", userId);
      this.$store.commit("setCurrentRole", roleCode);
      this.$store.commit("setCurrentRoleName", roleName);
      localStorage.setItem("authorization", token);
      this.$store.commit("setAuthorization", token);
      if (this.remberpass) {
        localStorage.setItem("remberpass", this.remberpass);
        localStorage.setItem("autologin", this.autologin);
        localStorage.setItem("username", this.formMail.mail);
        localStorage.setItem("password", this.formMail.password);
      }
      this.$store.commit("setCurrentUserId", userId);
      roleCode = data.authorityInfoList[0].roleCode;
      roleName = data.authorityInfoList[0].roleName;
      this.requestAuthorityData(roleCode);
      this.$store.commit("setUserAuthorityInfoList", []);
      this.toAccountBinding(data.email, data.phoneNumber, data);
    },
    toAccountBinding(email, phoneNumber, data) {
      if (!email && !phoneNumber) {
        this.$router.push({ name: "accountBinding" });
      } else {
        this.toComplementUnerInfo(data.name, data.org, data.sex, 1, "admin");
        // this.$router.push({name: 'home'})
      }
    },
    //完善用户信息
    toComplementUnerInfo(name, org, sex, isWillReview, adminstr) {
      if (!this.authorityObj.isShow("#5#64#66")) {
        //判断是评审人
        isWillReview = 1;
      }
      if (adminstr == "admin") {
        //判断是管理员
        isWillReview = 1;
      }
      if (name && org && sex && (isWillReview === 1 || isWillReview === 0)) {
        this.$store.commit("setIsFinishedInfo", true);
        this.$router.push({ name: "home" });
      } else {
        this.$store.commit("setIsFinishedInfo", false); //防止用户点击浏览器返回按钮
        this.$router.push({ name: "complementUnerInfo" });
      }
    },
    loginMail() {
      this.$refs.formMail.validate((valid) => {
        if (valid) {
          let form = {
            loginAccount: this.formMail.mail,
            password: this.formMail.password,
          };
          this.$api.loginByPassword(form).then((res) => {
            if (res.code === "200") {
              this.loginSuccess(res.data);
            } else {
              if (this.$i18n.locale == "en" && res.retMsgEn) {
                this.$message({
                  message: res.retMsgEn,
                  type: "error",
                });
              } else {
                this.$message({
                  message: res.retMsg,
                  type: "error",
                });
              }
            }
          });
        }
      });
    },
    loginChoiceRole(roleCode) {
      let meetingCode = this.dialogData.meetingCode;
      let email = this.dialogData.email;
      let phoneNumber = this.dialogData.phoneNumber;
      this.dialogFormVisible = true;
      this.requestAuthorityData(roleCode);
      this.setMeetingObj(meetingCode, meetingCode);
      this.toAccountBinding(email, phoneNumber);
    },
    loginMailAdmin() {
      this.$refs.formMail.validate((valid) => {
        if (valid) {
          let form = {
            loginAccount: this.formMail.mail,
            password: this.formMail.password,
          };
          localStorage.setItem("meetingCode", "admin");
          this.$api.loginByPasswordForAdmin(form).then((res) => {
            if (res.code === "200") {
              this.loginSuccess(res.data);
            } else {
              if (this.$i18n.locale == "en" && res.retMsgEn) {
                this.$message({
                  message: res.retMsgEn,
                  type: "error",
                });
              } else {
                this.$message({
                  message: res.retMsg,
                  type: "error",
                });
              }
            }
          });
        }
      });
    },
    loginMobile(val) {
      this.$refs.formMobile.validate((valid) => {
        if (valid) {
          let form = {
            loginAccount: this.formPhone.mobile,
            msgCode: this.formPhone.passcode,
          };
          if (val === "admin") {
            localStorage.setItem("meetingCode", "admin");
          }
          this.$api.loginByVerificationCodeOfPhone(form).then((res) => {
            if (res.code === "200") {
              this.loginSuccess(res.data);
            } else {
              if (this.$i18n.locale == "en" && res.retMsgEn) {
                this.$message({
                  message: res.retMsgEn,
                  type: "error",
                });
              } else {
                this.$message({
                  message: res.retMsg,
                  type: "error",
                });
              }
            }
          });
        }
      });
    },
    changeFunc(val) {
      // login register
      if (val == "register") {
        this.$router.push(
          "/register/" + this.$store.state.dict.currentMeetingCode
        );
      }
    },
    changeLoginRole(val) {
      if (val === "login") {
        this.$router.push({
          name: "login",
        });
      } else {
        this.$router.push({
          name: "adminLogin",
        });
      }
    },
    choseWayFunc(val) {
      //mail phone
      this.activeWay = val;
    },
    //验证码相关
    sendMessage() {
      const reg = /^1[3456789]\d{9}$/;
      if (!reg.test(this.formPhone.mobile)) {
        this.$message({
          message: this.$t("msg.rightPhone"),
          type: "error",
        });
        return;
      }
      this.sendCode = false;
      this.sendTime = 60;
      var auth_timetimer = setInterval(() => {
        this.sendTime--;
        if (this.sendTime <= 0) {
          this.sendCode = true;
          clearInterval(auth_timetimer);
        }
      }, 1000);
      this.$api
        .sendPhoneVerificationCode(
          { phoneNumber: this.formPhone.mobile },
          "post"
        )
        .then((res) => {
          if (res.code === "200") {
            this.$message({
              message: this.$t("msg.smsSuccess"),
              type: "success",
            });
          } else {
            this.$message({
              message: "短信验证码发送失败",
              type: "error",
            });
          }
        });
    },
    toFindPassBack() {
      localStorage.setItem("meetingCode", "admin");
      this.$router.push({
        name: "findpass",
      });
    },
    /**
     * 权限相关
     * */
    requestAuthorityData(role) {
      let data = {
        roleCode: role,
      };
      this.$api.getMenu(data, "postObj").then((res) => {
        if (res.code == 200) {
          this.authorityObj.setAuthorityData(res.data);
          this.authorityObj.setAuthorityButtonData(res.data);
          this.authorityObj.setAuthorityPageData(res.data);

          this.$store.commit("resetTabsList");

          if (this.authorityObj.isShowPage("#12#13")) {
            this.getMeetingList();
          }
        }
      });
    },
    //存储权限数据
    setAuthorityData() {
      let asideData = [
        {
          path: "/home",
          name: "home",
          label: "首页",
          icon: "s-home",
        },
      ]; //
      let resArr = this.authorityData;
      resArr.some((x) => {
        if (x.node.menuCode == "#5") {
          //#5
          let xobj = {};
          xobj.label = "用户管理";
          xobj.icon = "user";
          if (x.childNodes && x.childNodes.length > 0) {
            x.childNodes.some((y) => {
              if (y.node.menuCode == "#5#6") {
                xobj.path = "/user";
                xobj.name = "user";
                xobj.label = y.node.menuName;
              }
            });
          }
          asideData.push(xobj);
        }

        if (x.node.menuCode == "#12") {
          //#5
          let xobj = {};
          xobj.label = "会议管理";
          xobj.label = x.node.menuName;
          xobj.icon = "suitcase";
          if (x.childNodes && x.childNodes.length > 0) {
            xobj.children = [];
            x.childNodes.some((y) => {
              if (y.node.menuCode == "#12#13") {
                let inobj = {
                  path: "/meetManager",
                  name: "meetManager",
                  label: y.node.menuName,
                  icon: "s-comment",
                };
                xobj.children.push(inobj);
              }
            });
          }
          asideData.push(xobj);
        }

        if (x.node.menuCode == "#19") {
          //#5
          let xobj = {};
          xobj.label = "论文管理";
          xobj.label = x.node.menuName;
          xobj.icon = "s-promotion";
          if (x.childNodes && x.childNodes.length > 0) {
            x.childNodes.some((y) => {
              if (y.node.menuCode == "#19#20") {
                xobj.children = [];
                let inobj = {
                  path: "/Papers",
                  name: "Papers",
                  label: y.node.menuName,
                  icon: "setting",
                };
                xobj.children.push(inobj);
              }
            });
          }
          asideData.push(xobj);
        }

        if (x.node.menuCode == "#1") {
          //#5
          let xobj = {};
          xobj.label = "个人中心";
          xobj.label = x.node.menuName;
          xobj.icon = "s-custom";
          if (x.childNodes && x.childNodes.length > 0) {
            xobj.children = [];
            x.childNodes.some((y) => {
              if (y.node.menuCode == "#1#3") {
                let inobj = {
                  path: "/personCenterManager",
                  name: "personCenterManager",
                  label: y.node.menuName,
                  icon: "s-comment",
                };
                xobj.children.push(inobj);
              }
              if (y.node.menuCode == "#1#2") {
                let inobj = {
                  path: "/personCenterInfo",
                  name: "personCenterInfo",
                  label: y.node.menuName,
                  icon: "s-comment",
                };
                xobj.children.push(inobj);
              }
              if (y.node.menuCode == "#1#4") {
                let inobj = {
                  path: "/personCenterLogs",
                  name: "personCenterLogs",
                  label: y.node.menuName,
                  icon: "s-comment",
                };
                xobj.children.push(inobj);
              }
            });
          }
          asideData.push(xobj);
        }
      });

      this.$store.commit("setAsideData", asideData);
    },
    //设置按钮权限  数组保存
    setAuthorityButtonData() {
      let AuthorityButtonArr = [];

      let resArr = this.authorityData;
      resArr.some((x) => {
        if (x.childNodes && x.childNodes.length > 0) {
          x.childNodes.some((y) => {
            if (y.childNodes && y.childNodes.length > 0) {
              y.childNodes.some((z) => {
                let obj = {};
                obj.menuCode = z.node.menuCode;
                obj.menuName = z.node.menuName;
                AuthorityButtonArr.push(obj);
              });
            }
          });
        }
      });
      this.$store.commit("setAuthorityButtonArr", AuthorityButtonArr);
    },
    //设置页面权限  数组保存
    setAuthorityPageData() {
      let AuthorityPageArr = [];

      let resArr = this.authorityData;
      resArr.some((x) => {
        if (x.childNodes && x.childNodes.length > 0) {
          x.childNodes.some((y) => {
            let obj = {};
            obj.menuCode = y.node.menuCode;
            obj.menuName = y.node.menuName;
            AuthorityPageArr.push(obj);
          });
        }
      });
      this.$store.commit("setAuthorityPageArr", AuthorityPageArr);
    },
    setMeetingObj(meetingCode, meetingSubject) {
      if (meetingCode) {
        let obj = {};
        obj.value = meetingCode;
        obj.label = meetingSubject;
        this.$store.commit("setCurrentMeetingObj", obj);
        this.$store.commit("setCurrentMeetingCode", meetingCode);
      }
    },
    getMeetingList() {
      let data = {
        pageNo: 1,
        pageSize: 1000,
      };
      let options = [];
      this.$api.getMeetingList(data).then((res) => {
        if (res.code == 200) {
          res.data.data.some((x, i) => {
            let obj = {};
            obj.value = x.meetingCode;
            obj.label = x.meetingSubject;
            obj.labelEn = x.meetingSubjectEn;
            options.push(obj);
            // if(!this.meetingCode){
            if (i == 0) {
              this.meetingCode = x.meetingCode;
              this.$store.commit("setCurrentMeetingObj", obj);
              this.$store.commit("setCurrentMeetingCode", x.meetingCode);
            }
            // }
          });
          this.$store.commit("setMeetingList", options);
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
//  pc
@media screen and (min-width: 900px) {
  .loginpage {
    .el-form-item {
      margin-bottom: 20px;
    }
    .flex_center_between {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .loginHeader {
      width: 76%;
      margin: auto;
      padding-top: 6%;
      .leftBoxEn {
        height: 22px;
      }
      .leftBoxZh {
        height: 27px;
      }
      .rightBox {
        padding-right: 4%;

        ::v-deep.langBox {
          span {
            background: #3774fe;
            border-radius: 2px;
            color: #fff;
            border: 1px solid #3774fe;
            margin-left: 12px;
            padding: 6px 11px;
            cursor: pointer;
          }
        }
      }
    }
    .chose-way-out {
      span {
        padding-bottom: 4px;
      }
    }
    .out-box-login {
      .title-span {
        margin: 20px 0 40px 0;
      }
      .chose-way-out {
        margin-top: 42px;
      }
    }
    .device-type-cla {
      top: 18%;
    }
  }
  .endbox {
    height: 100vh;
    background: #bfd6fc;
  }
  .device-type-cla {
    width: 380px;
    position: absolute;
    right: 15%;
    top: 20%;
  }
  .loginpage {
    width: 100%;
    height: 100%;
    background: url(../../assets/login/bg.png) no-repeat center;
    background-size: 100% 100%;
  }
  .login-login {
    background: url(../../assets/images/logo-blue.png) no-repeat center;
    height: 18px;
    width: 200px;
    background-size: 100% 100%;
  }
}
@media screen and (min-width: 1000px) and (max-width: 1500px) {
  .loginHeader {
    padding-top: 8% !important;
  }
}
//android
@media screen and (max-width: 900px) {
  .h5Box {
    .flex_center {
      display: flex;
      align-items: center;
    }
    .leftBoxEn {
      top: 45%;
      width: 170px;
      position: absolute;
      right: 22px;
    }
    .leftBoxZh {
      top: 45%;
      height: 18px;
      position: absolute;
      right: 0;
    }
    .handleBox {
      justify-content: flex-end;
      padding-right: 12px;
      margin-top: -20px;
      position: relative;
      z-index: 2;
      margin-bottom: 20px;
    }

    ::v-deep.langBox {
      span {
        background: #3774fe;
        border-radius: 2px;
        color: #fff;
        border: 1px solid #3774fe;
        margin-left: 12px;
        padding: 3px 6px;
        cursor: pointer;
      }
    }
  }
  .endbox {
    height: 100vh;
    background: #eef4fe;
  }
  .loginpage {
    width: 100%;
    height: 100vh;
    background: #eef4fe;
    background-size: 100% 100%;
    overflow: hidden;
    padding: 0 20px;
  }
  .login-login {
    background: url(../../assets/images/logo-blue.png) no-repeat center;
    height: 18px;
    width: 200px;
    background-size: 100% 100%;
    margin: 30px auto 0;
  }
  .h5bg {
    position: relative;
    .titlogin {
      background: url(../../assets/images/logo-blue.png) no-repeat center;
      height: 18px;
      width: 200px;
      background-size: 100% 100%;
      position: absolute;
      top: 45%;
    }
  }
}

.out-box-login {
  //background: #f0f0f0;

  .title-span {
    width: 100%;
    margin: 20px 0 20px 0;
    height: 25px;
    font-size: 18px;
    font-weight: 500;
    color: #2a2a2a;
    line-height: 25px;
    text-align: center;
  }
  .chose-out {
    margin-top: 10%;
    border-radius: 2px;
    border: 1px solid #3774fe;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    .chose-in {
      font-size: 18px;
      color: #3774fe;
      display: inline-block;
      width: 49.9%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .chose-in.active {
      background: #3774fe;
      color: #fff;
    }
  }

  .chose-out-role {
    margin-top: 10%;
    border-radius: 2px;
    border: 1px solid #3774fe;
    width: 200px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    .chose-in {
      font-size: 10px;
      color: #3774fe;
      display: inline-block;
      width: 49.9%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .chose-in.active {
      background: #3774fe;
      color: #fff;
    }
  }

  .chose-way-out {
    justify-content: left;
    align-items: center;
    display: flex;
    margin: 16px 0;

    span {
      font-size: 16px;
      display: inline-block;
      cursor: pointer;
      border-bottom: 2px solid rgba(0, 0, 0, 0);
    }

    span.active {
      color: #3774fe;
      border-bottom: 2px solid #3774fe;
    }

    .shu {
      background: #999;
      width: 1px;
      height: 10px;
      margin: 0 10px;
    }
  }

  .me-button {
    border-radius: 2px;
    background: #3774fe;
    color: #fff;
    height: 48px;
    text-align: center;
    line-height: 48px;
    font-size: 16px;
    cursor: pointer;
    margin-top: 20px;
  }

  .me-button-login {
    border-radius: 2px;
    background: #3774fe;
    color: #fff;
    height: 48px;
    width: 100%;
    text-align: center;
    line-height: 48px;
    font-size: 16px;
    cursor: pointer;
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      margin-right: 5px;
    }
  }

  .little-btn-div {
    margin-top: 15px;

    .blue14 {
      cursor: pointer;
      color: #3774fe;
      font-size: 14px;
      float: right;
    }
  }

  .little-btn-divv2 {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 20px;
    margin-bottom: 20px;

    span {
      color: #ff625a;
      border: 1px solid #ff625a;
      margin-left: 5px;
      padding: 0 5px;
      cursor: pointer;
    }
  }
}

//.login-out{
//  display: flex;
//  position: absolute;
//  left:50%;
//  top:40%;
//  margin-left: -200px;
//  margin-top:-150px;
//  width:400px;
//  min-height:300px;
//  justify-content: center;
//  align-items: center;
//  background: #fff;
//}
//.el-form-item__error {
//  color: #f56c6c;
//  font-size: 12px;
//  line-height: 1;
//  padding-top: 4px;
//  position: absolute;
//  top: 100%;
//  left: 50px !important;
//}
//.login {
//  width: 400px;
//  height: 406px;
//  border: 1px solid #efefef;
//  margin: auto;
//}
//.el-checkbox {
//  margin-right: 63px !important;
//}
//.el-form-item__error {
//  margin-left: 50px !important;
//}
//.login-header {
//  height: 42px;
//  line-height: 42px;
//  background: #efefef;
//}
//.fl {
//  float: left;
//}
//.login-title {
//  margin-left: 15px;
//}
//.login-login {
//  background: url(../../assets/images/logo-max.jpg) no-repeat center;
//  height: 58px;
//  background-size: 100% 100%;
//  margin: 0px 30px 20px;
//}
//.el-input {
//  /*width: 300px;*/
//  height: 34px;
//  margin: auto;
//}
//.denglu {
//  width: 300px;
//  height: 34px;
//  line-height: 34px;
//  background: $mainColor;
//  border-radius: 5px;
//  margin: auto;
//}
//.login-dengl {
//  width: 300px;
//  height: 34px;
//  line-height: 34px;
//  background: $mainColor;
//  border: 0;
//  margin: 0px 30px;
//  cursor: pointer;
//  text-align: center;
//  color: #ffffff;
//}
//button {
//  border: none;
//  background-color: transparent;
//  color: #888888;
//}
//.el-form-item__error {
//  margin-left: 50px;
//  margin-top: 5px;
//}
//.el-input__inner {
//  height: 35px !important;
//  line-height: 35px !important;
//}
//.login-foot {
//  text-align: right;
//  margin-top: 30px;
//  margin-right: 42px;
//}
//.fr {
//  float: right;
//}
//
//::v-deep.el-dialog__header {
//  padding: 0px 30px;
//  text-align: left;
//  // background: #EFEFEF;
//  font-size: 18px;
//  font-family: PingFangSC-Medium, PingFang SC;
//  font-weight: 500;
//  color: rgba(0, 0, 0, 1);
//  line-height: 48px;
//}
//::v-deep.el-dialog__body {
//  padding: 0 20px 30px;
//}
</style>
<style>
.out-box-login .el-input__inner {
  height: 48px !important;
  line-height: 48px;
}
</style>
